import axios, { AxiosError } from 'axios'
import i18n from 'i18next'
import qs from 'qs'

import { injectTokenToRequest } from '../interceptors/injectToken'

import { ENV } from '~constants'
import { getApiError, signOutWhenNotAuthorized } from '~utils'

export type ApiError = {
  message: string
  errors: {
    [key: string]: string[]
  }
}

export const apiClient = axios.create({
  baseURL: ENV.API_URL,
  timeout: 30 * 1000,
  paramsSerializer: (params) => qs.stringify(params),
})

apiClient.interceptors.request.use(injectTokenToRequest, (error) => {
  return Promise.reject(error)
})

apiClient.interceptors.response.use(
  async (response) => {
    return response?.data?.data
  },
  async (error: AxiosError<ApiError>) => {
    const errorMessage = error?.response?.data?.message
    await signOutWhenNotAuthorized(error)
    if (errorMessage) {
      const api_error = getApiError(errorMessage)
      if (api_error) {
        return Promise.reject(new Error(api_error?.translation))
      }

      //FIXME: Delete this before deploy
      return Promise.reject(new Error('BE: ' + errorMessage))
    }
    if (error.message === 'Network Error') {
      return Promise.reject(new Error(i18n.t('errors.network')))
    }
    return Promise.reject(new Error(i18n.t('errors.something_went_wrong')))
  }
)
